module.exports = __webpack_public_path__ + "static/media/05-speaker_profile.5321badc.webp";